import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import logo from "./assets/Logo.png";

const HomePage = () => {
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    pincode: "",
    state: "",
    ref: "",
  });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const ref = queryParams.get("ref");
  const isCustomerFormPath = location.pathname === "/customer-form";

  useEffect(() => {
    if (ref) {
      setFormData((prev) => ({ ...prev, ref }));
    }
  }, [location, ref]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setError("");

    try {
      const response = await fetch("http://139.59.45.151/api/public/customers", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage("Customer added successfully!");
        setFormData({
          name: "",
          phone: "",
          email: "",
          address: "",
          city: "",
          pincode: "",
          state: "",
          ref: formData.ref, // Persist the ref
        });

        setTimeout(() => {
          setSuccessMessage("");
        }, 2000);
      } else {
        setError(data.message || "Failed to add customer");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const confirmLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const cancelLogout = () => {
    setShowConfirm(false);
  };

  // If on /customer-form path but 'ref' is missing, show error state
  if (isCustomerFormPath && !ref) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
        <div className="w-full max-w-md text-center bg-white p-8 rounded-2xl shadow-xl border border-gray-100">
          <img src={logo} alt="KarigarHQ Logo" className="mx-auto h-16 w-auto mb-6 opacity-50 grayscale" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Invalid Access</h2>
          <p className="text-gray-600 mb-6">
            This form is only accessible via a valid QR code link.
          </p>
          <div className="h-1 w-20 bg-cyan-400 mx-auto rounded-full"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4 py-12">
      <div className="w-full max-w-md space-y-8 bg-white p-8 rounded-2xl shadow-xl border border-gray-100">
        <div className="text-center">
          <img
            src={logo}
            alt="KarigarHQ Logo"
            className="mx-auto h-16 w-auto object-contain mb-6"
          />
          <h2 className="text-3xl font-bold tracking-tight text-gray-900">
            Welcome
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Please fill in your details to get started.
          </p>
        </div>

        <form className="mt-8 space-y-5" onSubmit={handleSubmit}>
          {successMessage && (
            <div className="bg-green-50 border-l-4 border-green-500 text-green-700 p-4 rounded-md shadow-sm text-sm">
              <span className="font-medium">Success!</span> {successMessage}
            </div>
          )}
          {error && (
            <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 rounded-md shadow-sm text-sm">
              <span className="font-medium">Error!</span> {error}
            </div>
          )}

          <div className="grid grid-cols-1 gap-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Full Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Ex. John Doe"
                className="block w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-20 outline-none transition-all duration-200 bg-gray-50 placeholder-gray-400 text-gray-900"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Phone Number</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Ex. +91 9988776655"
                className="block w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-20 outline-none transition-all duration-200 bg-gray-50 placeholder-gray-400 text-gray-900"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Ex. john@example.com"
                className="block w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-20 outline-none transition-all duration-200 bg-gray-50 placeholder-gray-400 text-gray-900"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Street address, apartment, etc."
                className="block w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-20 outline-none transition-all duration-200 bg-gray-50 placeholder-gray-400 text-gray-900"
                required
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">City</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="City"
                  className="block w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-20 outline-none transition-all duration-200 bg-gray-50 placeholder-gray-400 text-gray-900"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Pincode</label>
                <input
                  type="text"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  placeholder="Pincode"
                  className="block w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-20 outline-none transition-all duration-200 bg-gray-50 placeholder-gray-400 text-gray-900"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">State</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="State"
                className="block w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-20 outline-none transition-all duration-200 bg-gray-50 placeholder-gray-400 text-gray-900"
                required
              />
            </div>

            {formData.ref && (
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Referral Code</label>
                <input
                  type="text"
                  name="ref"
                  value={formData.ref}
                  readOnly
                  className="block w-full px-4 py-3 rounded-xl border border-gray-100 bg-gray-100 text-gray-500 cursor-not-allowed outline-none"
                />
              </div>
            )}
          </div>

          <button
            type="submit"
            className={`w-full py-4 px-6 mt-4 text-white font-bold rounded-xl shadow-lg transition-all duration-300 transform active:scale-95 ${
              loading 
                ? "bg-gray-400 cursor-not-allowed" 
                : "bg-black hover:bg-gray-800 hover:shadow-cyan-400/20"
            } flex items-center justify-center`}
            disabled={loading}
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin h-5 w-5 text-white mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 118 8v-4a4 4 0 10-4-4H4z"
                  ></path>
                </svg>
                Processing...
              </>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>

      {showConfirm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 p-4">
          <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-sm w-full text-center">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Ready to leave?
            </h3>
            <p className="text-gray-600 mb-8">
              Are you sure you want to log out of your session?
            </p>
            <div className="flex gap-4">
              <button
                className="flex-1 bg-red-600 text-white py-3 rounded-xl font-semibold hover:bg-red-700 transition-colors shadow-lg shadow-red-200"
                onClick={confirmLogout}
              >
                Logout
              </button>
              <button
                className="flex-1 bg-gray-100 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
                onClick={cancelLogout}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
